import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberEndorsementsPage from "@/pages/member/MemberEndorsementsPage";

export const Route = createFileRoute("/member/endorsements")({
  head: () => pageHead("Member · Endorsements", "AKIVA member · endorsements portal.", "/member/endorsements", true),
  component: MemberEndorsementsPage,
});
